import { Box, Stack } from '@mui/material';
import { Typography } from '../../primitives/typography/typography';
import { ReactNode } from 'react';
import { EmptyIcon } from '../../../assets/empty-icon';

export interface EmptyStateProps {
  message?: ReactNode;
  padding?: number;
}

export const EmptyState = ({ message = 'No items found.', padding = 3 }: EmptyStateProps) => (
  <Box sx={{ p: padding, textAlign: 'center' }}>
    <Typography.Subtitle>{message}</Typography.Subtitle>
  </Box>
);

/**
 * `message` is optional and defaults to the previous hardcoded copy, so every existing render is
 * unchanged. Added because an empty list is one of the few places a screen can say something
 * genuinely useful — "no certificates on file" is a compliance exposure, not a neutral absence —
 * and its sibling `EmptyState` already took a message while this one dropped it.
 */
export const EmptyStateWithIcon = ({ message = 'No items found' }: EmptyStateProps) => (
  <Stack
    sx={{ gap: 2, alignItems: 'center', justifyContent: 'center', height: { xs: 200, sm: 400 } }}
  >
    <EmptyIcon />
    <Typography.Subheading sx={{ color: 'text.secondary', textAlign: 'center', px: 3 }}>
      <Box>{message}</Box>
    </Typography.Subheading>
  </Stack>
);
